export enum ProfileRouteActionsName {
  CHANGE_USER_PERSONAL_DATA = "changeUserPersonalData",
  CHANGE_USER_PASSWORD = "changeUserPassword",
  CHANGE_PERMISSIONS = "changePermissions",
  CHANGE_USER_SETTINGS = "changeUserSettings",
  SHOW_ACTIVE_SESSIONS = "showActiveSessions",
}

